import { render, staticRenderFns } from "./LwfFormFilters.vue?vue&type=template&id=8c378c86&"
import script from "./LwfFormFilters.vue?vue&type=script&lang=js&"
export * from "./LwfFormFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports